import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../utils/axiosConfig";
import { ReactComponent as EditIcon } from "../../assets/edit.svg";

// Упрощенный компонент SVG-уголка (без стилей)
const CornerSVG = () => (
    <svg
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M0 10.0804H1.90743V1.82306H10.547V0H0V10.0804Z" fill="#00739F" />
    </svg>
);

const AvatarSection = ({ userInfo, updateUserData }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState("");
    const [cacheKey, setCacheKey] = useState(Date.now());
    const fileInputRef = useRef(null);

    // При обновлении userInfo.avatar обновляем cacheKey
    useEffect(() => {
        if (userInfo?.avatar) {
            setCacheKey(Date.now());
        }
    }, [userInfo?.avatar]);

    // Обработка изменения файла аватара
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            // Создание предварительного просмотра
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewUrl(reader.result);
            };
            reader.readAsDataURL(file);
            setIsEditing(true);
        }
    };

    // Сохранение аватара пользователя
    const handleSaveAvatar = () => {
        if (!selectedFile) {
            setIsEditing(false);
            return;
        }

        const formData = new FormData();
        formData.append('avatar', selectedFile);

        axiosInstance.post('/profile/save-avatar', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((res) => {
                if (res.data.success) {
                    setCacheKey(Date.now());
                    updateUserData({
                        avatar: res.data.avatarUrl
                    });
                    setSelectedFile(null);
                    setPreviewUrl("");
                    setIsEditing(false);
                }
            })
            .catch((error) => console.log("Ошибка загрузки аватара", error));
    };

    // Получаем фото пользователя из Telegram
    const getTelegramPhotoUrl = () => {
        if (!window.Telegram?.WebApp?.initDataUnsafe?.user) return null;
        return window.Telegram.WebApp.initDataUnsafe.user.photo_url || null;
    };

    // Формирование URL аватара с учетом структуры сервера
    const getAvatarUrl = () => {
        if (previewUrl) {
            return previewUrl;
        }

        // Сначала проверяем userInfo.avatar
        if (userInfo?.avatar) {
            return userInfo.avatar;
        }

        // Если нет userInfo.avatar, пробуем получить из Telegram
        const telegramId = window.Telegram?.WebApp?.initDataUnsafe?.user?.id;

        if (telegramId) {
            // Получаем расширение из URL аватара, если оно есть
            const avatarExt = userInfo?.avatar ? userInfo.avatar.split('.').pop().split('?')[0] : 'jpg';
            const baseUrl = 'https://elitelegion.ru';
            const url = `${baseUrl}/uploads/avatars/${telegramId}.${avatarExt}?cache=${cacheKey}`;
            return url;
        }

        return getTelegramPhotoUrl();
    };

    // Функция для открытия файлового диалога
    const handleEditClick = () => {
        fileInputRef.current.click();
    };

    return (
        <div className="profile-avatar-section">
            <div className="avatar-container">
                <img
                    src={getAvatarUrl()}
                    alt="Фото профиля"
                    className="profile-avatar-img"
                    key={cacheKey}
                    onError={(e) => {
                        console.error('Ошибка загрузки аватара:', e.target.src);
                        const telegramPhoto = getTelegramPhotoUrl();
                        if (telegramPhoto) {
                            console.log('Используем фото из Telegram:', telegramPhoto);
                            e.target.src = telegramPhoto;
                        } else {
                            console.log('Используем дефолтный аватар');
                            e.target.src = '/default-avatar.png';
                        }
                    }}
                />

                {/* Уголки - стили перенесены в CSS */}
                <div className="corner top-left"><CornerSVG /></div>
                <div className="corner top-right"><CornerSVG /></div>
                <div className="corner bottom-left"><CornerSVG /></div>

                {/* Скрытый input для выбора файла */}
                <input
                    type="file"
                    ref={fileInputRef}
                    id="avatar-upload"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="file-input"
                />

                {/* Кнопка редактирования в правом нижнем углу */}
                {!isEditing && (
                    <button
                        className="avatar-edit-btn"
                        onClick={handleEditClick}
                    >
                        <EditIcon className="edit-icon" />
                    </button>
                )}

                {/* Кнопка сохранения, видимая только в режиме редактирования */}
                {isEditing && (
                    <div className="avatar-save-container">
                        <button
                            className="avatar-save-btn"
                            onClick={handleSaveAvatar}
                        >
                            Сохранить
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AvatarSection; 